import { invokeArgs, pipe } from 'lodash/fp';

import moment from 'moment';

export function routeParamToShortDate(routeParam)
{
  return pipe
  ([
    moment,
    invokeArgs('format')(['MM-DD']),
  ])
  (routeParam);
}